export {
    featureFlagsPlugin,
    resourceTimingsPlugin,
    hasTimingHeaders,
    sanitizers,
    sanitiseEndpoints,
    customPerfMarks,
} from './browser-metrics-v3-plugins';
